"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_router_1 = require("react-router");
var Routes_1 = require("../../../common/enum/Routes");
var JourneyStepsRoutes_1 = require("../enum/JourneyStepsRoutes");
var UrlParamTypes_1 = require("../../../common/enum/UrlParamTypes");
var usePlatformConfig_1 = require("../../../common/react/usePlatformConfig");
var Checkout4Redirects = function () {
    var isCheckout4Enabled = usePlatformConfig_1.default().platformConfig.platformFeatures.isCheckout4Enabled;
    var history = react_router_1.useHistory();
    var _a = react_router_1.useLocation(), pathname = _a.pathname, queryString = _a.search;
    var searchParams = new URLSearchParams(queryString);
    var from = searchParams.get(UrlParamTypes_1.UrlParamTypes.FROM) || '';
    var token = searchParams.get(UrlParamTypes_1.UrlParamTypes.TOKEN) || '';
    var confirmationRouteMatch = react_router_1.matchPath(pathname, {
        path: [Routes_1.Routes.CONFIRMATION_REQUEST_QUOTE, Routes_1.Routes.CONFIRMATION_RESERVE_ONLINE],
    });
    var paymentRouteMatch = react_router_1.matchPath(pathname, {
        path: [Routes_1.Routes.PAYMENT],
    });
    var nextStepsRouteMatch = react_router_1.matchPath(pathname, {
        path: [Routes_1.Routes.REQUEST_QUOTE, Routes_1.Routes.RESERVE_ONLINE],
    });
    react_1.useEffect(function () {
        if (isCheckout4Enabled) {
            var search = UrlParamTypes_1.UrlParamTypes.TOKEN + "=" + token + (from ? "&" + UrlParamTypes_1.UrlParamTypes.FROM + "=" + from : '');
            if (confirmationRouteMatch) {
                history.replace({
                    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.CONFIRMATION,
                    search: search,
                });
            }
            else if (paymentRouteMatch) {
                history.replace({
                    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.PAYMENT,
                    search: search,
                });
            }
            else if (nextStepsRouteMatch) {
                history.replace({
                    pathname: JourneyStepsRoutes_1.JourneyStepsRoutes.NEXT_STEPS,
                    search: search,
                });
            }
        }
    }, [history, isCheckout4Enabled, paymentRouteMatch, confirmationRouteMatch, nextStepsRouteMatch, pathname]);
    return null;
};
exports.default = Checkout4Redirects;
